import { render, staticRenderFns } from "./SelectPerson.vue?vue&type=template&id=ca30d8b6"
import script from "./SelectPerson.vue?vue&type=script&lang=js"
export * from "./SelectPerson.vue?vue&type=script&lang=js"
import style0 from "./SelectPerson.vue?vue&type=style&index=0&id=ca30d8b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports